import { UpdateTaxpayerFormDataArgs } from '../types/form'

export const updateTaxpayerFormDataArgsToParams = ({
  countryOfTaxResidency,
  firstName,
  lastName,
  birthdate,
  billingAddressId,
  taxIdentificationNumber,
  birthplaceCountry,
  birthplaceCity,
  businessName,
  businessCode,
  secondaryBusinessCode,
  vatNumber,
  businessAddressId,
  businessEstablishmentCountries,
  address,
}: UpdateTaxpayerFormDataArgs) => ({
  taxpayer: {
    first_name: firstName,
    last_name: lastName,
    birthdate,
    country_of_tax_residency: countryOfTaxResidency,
    tin: taxIdentificationNumber,
    billing_address_id: billingAddressId,
    birthplace_country: birthplaceCountry,
    birthplace_city: birthplaceCity,
    business_name: businessName,
    business_code: businessCode,
    secondary_business_code: secondaryBusinessCode,
    vat_number: vatNumber,
    business_address_id: businessAddressId,
    business_establishment_countries: businessEstablishmentCountries,
    address: {
      external_user_address_id: address?.externalUserAddressId,
      name: address?.name,
      line1: address?.line1,
      line2: address?.line2,
      city: address?.city,
      postal_code: address?.postalCode,
      state: address?.state,
      country_code: address?.countryCode,
    },
  },
})
